import React from "react";
import "./App.css";

// React Router v6 functions for routing
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Global toast notification system
import { Toaster } from "./components/ui/sonner";

// Main layout wrapper for public-facing pages
import Layout from "./components/Layout";

// Public-facing pages
import Home from "./pages/Home";

// Grouped route modules
// These files contain nested routing (child routes) for cleaner structure
import DocRoutes from "./routes/DocRoutes";

/**
 * App Component
 * - Root component of the entire application
 * - Sets up BrowserRouter and global route structure
 * - Registers global components like Toaster
 */
function App() {
  return (
    <div className="App">
      {/* BrowserRouter enables routing for the entire application */}
      <BrowserRouter>
        <Routes>
          {/*
            PUBLIC LAYOUT ROUTES
            ---------------------
            This covers all main website pages such as:

            All these pages are wrapped inside the <Layout> component, which
            includes navigation bar, footer, and shared layout structure.

            The wildcard "*" ensures ALL routes under "/" go through LayoutRoutes.
          */}
          <Route path="/*" element={<LayoutRoutes />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

/**
 * LayoutRoutes Component
 * ----------------------
 * This function component wraps all public-facing pages with the <Layout> component.
 * It isolates "presentation routes" into a clean group.
 *
 * Every route inside LayoutRoutes will be rendered INSIDE the Layout,
 * meaning Layout stays persistent while child routes change.
 */
const LayoutRoutes = () => {
  return (
    <Layout>
      <Routes>
        {/* Public landing page */}
        <Route path="/" element={<Home />} />

        {/* Documentation routes (nested routes inside DocRoutes) */}
        <Route path="/docs/*" element={<DocRoutes />} />
      </Routes>
    </Layout>
  );
};

export default App;
